// extracted by mini-css-extract-plugin
module.exports = {"parent":"desktop_parent__38dxS","child":"desktop_child__25Xf2","sec1":"desktop_sec1__15EoW","Whowe":"desktop_Whowe__1MKXA"};